import { useSetAtom } from 'jotai';
import React, { Suspense, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';
import { PanelBody } from '../../components/designer/panels/PanelBody';
import { Container } from '../../components/layout/ContainerFlex';
import LoadingIndicator from '../../components/LoadingIndicator';
import ActualityViewModeToggle from '../components/ActualityViewModeToggle';
import { actualityAggregatedStatsViewMode } from '../store/actuality.kpi.state';
import { actualityAggregatedStatsAllSelectedWhenEmpty } from '../store/actuality.kpi.ui.state';
import ActualityAggregatedStatsGroupsSection from './ActualityAggregatedStatsGroupsSection';
import ActualityAggregatedStatsSummarySection from './ActualityAggregatedStatsSummarySection';

type ActualityAggregatedStatsPanelProps = {
  allSelectedWhenNoExplicitSelection?: boolean;
  displayMode?: 'summary' | 'details' | 'process' | 'events';
};

const ActualityAggregatedStatsPanel: React.FC<
  ActualityAggregatedStatsPanelProps
> = props => {
  const { t } = useTranslation('feed');
  const viewMode = useRecoilValue(actualityAggregatedStatsViewMode);
  const setAllSelectedWhenEmpty = useSetAtom(
    actualityAggregatedStatsAllSelectedWhenEmpty,
  );
  useEffect(() => {
    setAllSelectedWhenEmpty(props.allSelectedWhenNoExplicitSelection);
  }, [props.allSelectedWhenNoExplicitSelection]);

  return (
    <PanelBody
      data-component="ActualityAggregatedStatsPanel"
      className="h-full !overflow-hidden"
    >
      {props.displayMode !== 'process' && <ActualityViewModeToggle />}

      <Suspense
        fallback={
          <Container col className="relative !p-2">
            <LoadingIndicator message={t`Loading Summary`} selfCenter />
          </Container>
        }
      >
        {props.displayMode !== 'process' && viewMode === 'summary' && (
          <ActualityAggregatedStatsSummarySection />
        )}
        {(props.displayMode === 'process' || viewMode === 'details') && (
          <ActualityAggregatedStatsGroupsSection
            displayMode={props.displayMode}
          />
        )}
      </Suspense>
    </PanelBody>
  );
};

export default ActualityAggregatedStatsPanel;
